import React         from 'react';
import TextAreaInput from './TextAreaInput';
import Label         from './Label';
import Tooltip       from './Tooltip';

const TextAreaComponent = props => (
  <div className="form-group">
    <Label label={props.label} required={props.required} /> <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
    <TextAreaInput {...props} />
  </div>
);

TextAreaComponent.defaultProps = {
  label   : 'Text Component',
  required: false,
};

export default TextAreaComponent;
